var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 17H18V7H14V17ZM12 6.007C12 5.45 12.453 5 12.997 5H19.003C19.553 5 20 5.45 20 6.007V17.993C20 18.549 19.547 19 19.003 19H12.997C12.447 19 12 18.55 12 17.993V6.007Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5H5C4.44772 5 4 5.44772 4 6C4 6.55228 4.44772 7 5 7H9C9.55228 7 10 6.55228 10 6C10 5.44772 9.55228 5 9 5Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9H5C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11H9C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13H5C4.44772 13 4 13.4477 4 14C4 14.5523 4.44772 15 5 15H9C9.55228 15 10 14.5523 10 14C10 13.4477 9.55228 13 9 13Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17H5C4.44772 17 4 17.4477 4 18C4 18.5523 4.44772 19 5 19H9C9.55228 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17Z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.9d410f1eb8c165b847590e9b328c83db.svg";
export { ForwardRef as ReactComponent };